<template>
  <section>
    <div class="carousel">
      <el-carousel
        v-if="imgs.length"
        ref="carouselDto"
        :interval="4000"
        :height="height"
        indicator-position="none"
        :autoplay="false"
        class="carousel-dto"
        @change="carouseFn"
      >
        <el-carousel-item
          v-for="(item1, index1) in imgs"
          :key="index1"
          :name="index1.toString()"
        >
          <div class="carousel-dto-item">
            <div v-if="isShowVr" class="vr" @click="handleRouteDto(item1)" />
            <img
              :src="item1.cover_img"
              alt=""
              :style="{ height }"
              @click="handleRouteDto(item1)"
            >
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="carousel-label">
        <!-- <el-button
          type="text"
          icon="el-icon-arrow-left"
          @click="handlePrev"
          v-if="imgs.length"
        ></el-button> -->
        <div id="carousel-label-imgs">
          <!-- <div class="carousel-label-imgs-item" :style="{ transform: 'translateX(' + currentOffset + 'px)' }">
            <img
              v-for="(item2, index2) in imgs"
              :key="index2"
              :src="item2.cover_img"
              :style="{ minWidth: width }"
              @click="handleControl(index2)"
            >
          </div> -->
          <Thumbnail
            :img-list="imgs"
            :item-width="60"
            :item-height="60"
            :interval="4"
            :active-index="activeIndex"
          >
            <template slot="imgItem" slot-scope="{item,index}">
              <ThumbnailImg
                width="80px"
                height="60px"
                :src="item.cover_img"
                @click.native="handleControl(index)"
              />
            </template>
          </Thumbnail>
        </div>
        <!-- <el-button
          type="text"
          icon="el-icon-arrow-right"
          @click="handleNext"
          v-if="imgs.length"
        ></el-button> -->
      </div>
    </div>
  </section>
</template>

<script>
import Thumbnail from '@/components/thumbnail'
import ThumbnailImg from '@/components/thumbnail/ThumbnailImg'
export default {
  name: 'ComCarousel',
  components: {
    Thumbnail,
    ThumbnailImg
  },
  props: {
    imgs: {
      type: Array,
      default: () => {
        return []
      }
    },
    // dto
    height: {
      type: String,
      default: '400px'
    },
    isShowVr: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentOffset: 0,
      width: '',
      fatherWith: 0,
      activeIndex: 0
    }
  },
  computed: {},
  watch: {},
  mounted() {
    // this.setCardWidth()
    // window.addEventListener('resize', () => {
    //   this.currentOffset = 0
    //   this.setCardWidth()
    // },

    // )
  },
  methods: {
    // setCardWidth() {
    //   this.$nextTick(() => {
    //     const father = document.getElementById('carousel-label-imgs')
    //     this.fatherWith = father.clientWidth
    //     this.width = (this.fatherWith - 20) / 8 + 'px'
    //   })
    // },

    // handleNext() {
    //   if (this.currentOffset <= (-(this.fatherWith - 20) / 8) * (10 - 8)) { return }
    //   this.currentOffset -= (this.fatherWith - 20) / 8
    // },
    // handlePrev() {
    //   if (this.currentOffset >= -2) return
    //   this.currentOffset += (this.fatherWith - 20) / 8
    // },
    handleControl(v) {
      this.activeIndex = v
      this.$refs.carouselDto.setActiveItem(v)
    },
    handleRouteDto(v) {
      this.$emit('routeDto', v)
    },
    carouseFn(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style scoped lang="scss">
.carousel {
  display: flex;
  flex-direction: column;
  height: 100%;
  &-label {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 5px;
    > div {
      width: 100%;

      // overflow: hidden;
      // > div {
      //   display: flex;
      //   transition: all 0.2s;
      //   > img {
      //     height: 60px;
      //     margin: 0 2px;
      //     &:first-child{
      //       margin-left: 0;
      //     }
      //     &:last-child{
      //       margin-right: 0;
      //     }
      //   }
      // }

    }
    &-imgs{
        width: 100%;
      }
    > button {
      color: #fff;
      height: 60px;
      width: 30px;
      background-color: #d7d7d7;
      &:nth-child(2) {
        left: -5px;
        margin-right: 2px;
      }
      &:nth-child(3) {
        right: -5px;
        margin-left: 2px;
      }
    }
  }
  &-dto-item {
    position: relative;
    .vr {
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      background-color: rgba(0, 0, 0, 0.6);
      transform: translate(-50%, -50%);
      line-height: 31px;
      margin-right: 15px;
      border-radius: 100px;
      background: url(https://s1.ljcdn.com/matrix_pc/dist/pc/src/resource/flat/vr-animation.png?v=1630381164939);
      background-position-y: 0;
      background-repeat: no-repeat;
      background-size: 100%;
      border: 1px solid #fff;
      -webkit-animation: mymove 3.5s steps(53) infinite;
      animation: mymove 3.5s steps(53) infinite;
      @keyframes mymove {
        from {
          background-position: 0% 0%;
        }
        to {
          background-position: 100% 100%;
        }
      }

      @-webkit-keyframes mymove /*Safari and Chrome*/ {
        from {
          background-position: 0% 0%;
        }
        to {
          background-position: 100% 100%;
        }
      }
    }
    > img{
      width: 100%;
    }
  }
  img {
    cursor: pointer;
  }
}
[class^="el-icon-arrow-"] {
  font-size: 22px;
  padding: 10px 0;
  background-color: rgba(0, 0, 0, 0);
}

</style>
